module.exports = __webpack_public_path__ + "static/pencil-7b08ec49d370e204b74bdf6a8f89f8ec.png";